import logo from "./dictionary2.jpg";
import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} className="App-logo img-fluid" alt="logo" />
        </header>
        <main>
          <Dictionary defaultKeyword="sunset" />
        </main>
        <footer className="App-footer">
        <small>
						This page was coded by Ayesha Khan, is open-sourced on{' '}
						<a href='https://github.com/khannnn88/dictionaryreact-app'>
							GitHub
						</a>{' '}
						and hosted on{' '}
						<a href='https://golden-starship-d45c39.netlify.app/'>
							Netlify
						</a>
						.
					</small>
        </footer>
      </div>
    </div>
  );
}